module.exports = __webpack_public_path__ + "img/accounts.11e82060.png";